export function getClientTimeZone(): string {
    let sign = '-';
    let offset = new Date().getTimezoneOffset();
    if (offset <= 0) {
        sign = '+';
        offset = Math.abs(offset);
    }
    let hours = Math.floor(offset / 60).toString();
    if (hours.length === 1) {
        hours = `0${hours}`;
    }
    let minutes = (offset % 60).toString();
    if (minutes.length === 1) {
        minutes = `0${minutes}`;
    }

    return `UTC${sign}${hours}:${minutes}`;
}
